import { useState } from "react";
import { LogOut } from "lucide-react";
import * as AlertDialog from "@radix-ui/react-alert-dialog";
import { useAuth } from "@/context/AuthContext";
import { countDrafts } from "@/lib/drafts";

// warns before signing out when unsent text is still on this device
export const LogoutButton = ({ className, testId, icon = false }) => {
  const { user, logout } = useAuth();
  const [asking, setAsking] = useState(false);
  const click = async () => {
    if (user && (await countDrafts(user.user_id)) > 0) setAsking(true);
    else logout();
  };
  return (
    <>
      <button type="button" className={className} onClick={click} data-testid={testId}>
        {icon && <LogOut size={14} strokeWidth={1.75} />} Cerrar sesión
      </button>
      <AlertDialog.Root open={asking} onOpenChange={setAsking}>
        <AlertDialog.Portal>
          <AlertDialog.Overlay className="sheet-overlay !z-[60]" />
          <AlertDialog.Content data-testid="logout-draft-dialog"
            className="[animation:fade-in_200ms_ease] fixed z-[61] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100vw-2.5rem)] max-w-[420px] bg-hoja border border-linea rounded-[24px] p-6">
            <AlertDialog.Title className="sr-only">Cerrar sesión</AlertDialog.Title>
            <AlertDialog.Description className="text-[16px] text-tinta leading-relaxed">
              Hay texto que todavía no se guarda. Si cierras sesión ahora, se borrará de este dispositivo.
            </AlertDialog.Description>
            <div className="mt-5 flex flex-wrap gap-2 justify-end">
              <AlertDialog.Cancel className="btn-primary" data-testid="logout-draft-wait">Esperar</AlertDialog.Cancel>
              <AlertDialog.Action className="btn-secondary" onClick={() => logout()} data-testid="logout-draft-confirm">Cerrar sesión de todos modos</AlertDialog.Action>
            </div>
          </AlertDialog.Content>
        </AlertDialog.Portal>
      </AlertDialog.Root>
    </>
  );
};
